import { Button, FormHelperText, Grid } from "@mui/material";
import React, { useState } from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { ViewImage } from "./ViewImage.component";

export function CustomImagePicker({
  error,

  selectedImages,
  setSelectedImages,
  pickerId,
  multiple,
}) {
  const [fileInputKey, setFileInputKey] = useState(0);

  const handleImageSelect = (event) => {
    let images = [];
    [...event.target.files].forEach((file) => {
      images.push({ image: file, name: file.name });
    });
    setSelectedImages(multiple ? [...selectedImages, ...images] : [...images]);
    setFileInputKey(fileInputKey + 1);
  };

  const handleImageRemove = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  return (
    <div>
      <label htmlFor={`upload-${pickerId}-photo`}>
        <br />
        <input
          style={{ display: "none" }}
          id={`upload-${pickerId}-photo`}
          name={`upload-${pickerId}-photo`}
          type="file"
          accept=".jpg,.png"
          multiple={multiple}
          onChange={handleImageSelect}
        />
        <Fab
          sx={{ p: "20px", mb: 1, fontSize: "12px" }}
          color="primary"
          size="small"
          component="span"
          aria-label="add"
          variant="extended"
        >
          <AddIcon sx={{ mb: "3px", fontSize: "14px" }} /> Add {pickerId}
          {multiple ? " image(s)" : "image"}
        </Fab>
        <FormHelperText sx={{ fontSize: "15px" }} error={error && true}>
          {selectedImages.length > 0
            ? `${selectedImages.length} images selected`
            : error !== ""
            ? error
            : `Upload ${pickerId}  images of the received product`}
        </FormHelperText>
      </label>

      {selectedImages.map((imageObject, index) => (
        <Grid container key={index}>
          <Grid item xs={12}>
            {imageObject.sampleImageURL && (
              <ViewImage productImage={imageObject} />
            )}
            {imageObject.image && (
              <img
                src={URL.createObjectURL(imageObject.image)}
                alt={` ${index}`}
                style={{ width: "100px" }}
              />
            )}
            {imageObject.base64 && (
              <img
                src={imageObject.base64}
                alt={` ${index}`}
                style={{ width: "100px" }}
              />
            )}
          </Grid>
          <Button
            sx={{
              mt: 3,

              mb: 3,
            }}
            color="error"
            onClick={() => handleImageRemove(index)}
          >
            Remove
          </Button>
        </Grid>
      ))}
    </div>
  );
}
